import React from "react"
import Expertise from "./expertise"
import { StaticQuery, graphql } from "gatsby"

const Service = () => (
  <StaticQuery
    query={graphql`
      query {
        service: contentfulTcStatic(contentful_id: {eq: "3uiEJkP3t3qpH6Uz2Oyqyh"}) {
          titleString
          id
          textContent {
            childMarkdownRemark {
              html
            }
          }
        }
      }
    `
    }
    render = {data => (

      <section class="section" div="services">
        <div class="container is-fluid wrapper standard-margin">
        <br/>
        <br/>
        <h1 class="title has-text-primary has-text-weight-light">{data.service.titleString}</h1>
        <h2 class="subtitle has-text-weight-light">
          <div dangerouslySetInnerHTML={{ __html: data.service.textContent.childMarkdownRemark.html}}/>
        </h2>
        <hr class="hr"/>

        <br/>
        <br/>
        <Expertise/>
        </div>
      </section>


    )}
    />
    )



export default Service
